import { useParams } from 'react-router';

import { useMemo } from 'react';

import { useI18n } from '@app-velocity/i18n';
import { RestartIcon } from '@app-velocity/icons';

import { Alert, ButtonsContainer } from '@app-velocity/ui';

import { SimpleStatus } from '@app-velocity/common';
import { useCurrentTeamPermissions } from '@app-velocity/libs/team-permissions';

import { useAIReviewStatusContext } from '../hooks/useAIReviewStatusContext';
import { useUserSimulationControl } from '../../../hooks/useUserSimulationControl';
import { useScenarioDetailsContext } from '../../../hooks/useScenarioDetailsContext';

export const Restart = () => {
  const { t } = useI18n();

  const currentTeam = useCurrentTeamPermissions();
  const { review } = useAIReviewStatusContext();
  const { teamId, workspaceId } = useParams<{
    teamId: string;
    workspaceId: string;
  }>();
  const { scenario } = useScenarioDetailsContext();
  const { start } = useUserSimulationControl();

  const handleRetry = () => {
    if (!scenario || !workspaceId || !teamId || !currentTeam) return;

    if (!currentTeam.canRunSimulations(1)) {
      return;
    }

    start(teamId, workspaceId, scenario.id!, 'default', 1, true);
  };

  const status: SimpleStatus = useMemo(() => {
    if (
      review.finishStatus &&
      [
        'ABORTED',
        'ABORTED_CYCLE_DETECTED',
        'ABORTED_PAGE_CYCLE_DETECTED',
      ].includes(review.finishStatus)
    )
      return 'warning';

    return 'error';
  }, [review.finishStatus]);

  if (
    review.reviewStatus !== 'CANCELED' ||
    review.finishStatus === 'ABORTED_ERROR'
  )
    return null;

  return (
    <ButtonsContainer>
      <Alert.ActionButton status={status} onClick={handleRetry}>
        {t('prototypes:try_again')} <RestartIcon />
      </Alert.ActionButton>
    </ButtonsContainer>
  );
};
